import RepositoriesList from './RepositoriesList';

export default RepositoriesList;
